var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_375_3429)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_375_3429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2H2V4H0V2ZM2 4H4V6H2V4ZM4 6H6V8H4V6ZM6 4H8V6H6V4ZM8 2H10V4H8V2ZM10 0H12V2H10V0Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_375_3429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_375_3429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.707e7fcd7382e69f1801d221ce4116c0.svg";
export { ForwardRef as ReactComponent };